import {useEffect, useState} from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import styles from './fundAllocation.module.scss';
import plusIcon from 'images/plus-circle.png';
import deleteIcon from 'images/delete.svg';
import SubmitButton from 'components/Startup/components/SubmitButton';
import {Form, Input} from 'antd';
import FadeEffect from 'components/animation/fadeEffect';
import {useDispatch, useSelector} from 'react-redux';
import {fundAllocation} from 'redux/store/campaign';
import StageHeader from 'pages/campaigns/new/components/StageHeader';
import ErrorSummary from 'pages/campaigns/new/components/ErrorSummary';
import FieldError from 'pages/campaigns/new/components/FieldError';
import {useStageValidation} from 'pages/campaigns/new/components/useStageValidation';

const FundAllocation = () => {
  const [description, setDescription] = useState('');
  const [disableButton, setDisableButton] = useState(true);
  const [fundValues, setFundValues] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {id, companyId} = useParams();
  const {errors, validate, clearError} = useStageValidation();

  const campaign = useSelector(state => state.campaign.campaign);

  useEffect(() => {
    if (campaign?.fundAllocation != undefined) {
      setDescription(campaign?.fundDescription);
      setFundValues(
        campaign?.fundAllocation?.map(data => ({
          sector: data.sector,
          percentage: data.percentage,
        })),
      );
    }
  }, [campaign?.fundAllocation]);

  useEffect(() => {
    fundValues?.map(data =>
      setDisableButton(!data.sector || !data?.percentage),
    );
  }, [fundValues]);

  const handleAddFunds = () => {
    setFundValues([...fundValues, {sector: '', percentage: 0}]);
  };

  const onDeleteFunds = id => {
    const filteredFormValue = fundValues.filter((item, index) => index !== id);
    setFundValues(filteredFormValue);
  };

  const handleFundsValueChange = (i, e) => {
    const newFormValues = [...fundValues];
    newFormValues[i][e.target.name] = e.target.value;
    setFundValues(newFormValues);
  };

  const handleSave = () => {
    const isEmpty = value =>
      value === undefined ||
      value === null ||
      value === '' ||
      (typeof value === 'string' && value.trim() === '') ||
      (typeof value === 'number' && Number.isNaN(value));
    const rules = [
      {
        field: 'description',
        valid: !isEmpty(description),
        message: 'Description is required',
      },
    ];
    fundValues?.forEach((data, index) => {
      rules.push({
        field: `sector${index}`,
        valid: !isEmpty(data?.sector),
        message: `Allocation Category (row ${index + 1}) is required`,
      });
      rules.push({
        field: `percentage${index}`,
        valid: !isEmpty(data?.percentage),
        message: `Percentage (row ${index + 1}) is required`,
      });
    });
    if (!validate(rules)) return;
    dispatch(
      fundAllocation({
        fundAllocation: fundValues,
        fundDescription: description,
      }),
    );
    navigate(`/dashboard/campaigns/new/${id}/investment/${companyId}`);
  };

  return (
    <div className={styles.container}>
      <Form layout="vertical">
        <ErrorSummary fields={Object.values(errors)} />
        <div className={styles.body}>
          <StageHeader
            title="Fund Allocation"
            description="Break down how the raised funds will be allocated."
          />
          <div>
            <Form.Item
              style={{width: 720}}
              name="description"
              label="Description"
              initialValue={campaign?.fundDescription}
              rules={[{required: true, message: 'Required Field'}]}>
              <Input.TextArea
                rows={6}
                defaultValue={campaign?.fundDescription}
                value={description}
                onChange={e => {
                  setDescription(e.target.value);
                  clearError('description');
                }}
                name="description"
              />
            </Form.Item>
            <FieldError message={errors.description} />
            <div>
              {fundValues?.map((data, index) => (
                // eslint-disable-next-line react/jsx-key
                <FadeEffect>
                  <div className={styles.form}>
                    <div key={index} className={styles['al-card']}>
                      <Form.Item label="Allocation Category">
                        <Input
                          name="sector"
                          value={data.sector}
                          onChange={e => handleFundsValueChange(index, e)}
                          style={{width: 400}}
                          placeholder="Marketing"
                        />
                      </Form.Item>
                      <Form.Item
                        style={{width: 288, marginLeft: 24}}
                        label="Percentage">
                        <Input
                          name="percentage"
                          value={data.percentage}
                          onChange={e => handleFundsValueChange(index, e)}
                          placeholder="% in value"
                          type="number"
                        />
                      </Form.Item>
                      <div className={styles['delete-icon']}>
                        <img
                          onClick={() => onDeleteFunds(index)}
                          src={deleteIcon}
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                </FadeEffect>
              ))}
            </div>
            <div onClick={handleAddFunds} className={styles['add-button']}>
              <img src={plusIcon} alt="" />
              <h1>Add Category</h1>
            </div>
          </div>
        </div>
        <div>
          <SubmitButton
            type="button"
            disabled={disableButton}
            label="Save & Continue"
            handleClick={handleSave}
          />
        </div>
      </Form>
    </div>
  );
};

export default FundAllocation;
